import { render, staticRenderFns } from "./ListCourseEnrollment.vue?vue&type=template&id=b06389f0&scoped=true&"
import script from "./ListCourseEnrollment.vue?vue&type=script&lang=js&"
export * from "./ListCourseEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./ListCourseEnrollment.vue?vue&type=style&index=0&id=b06389f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06389f0",
  null
  
)

export default component.exports